<script>
import BoxComponent from './BoxComponent';

export default {
    name: 'PdfViewer',
    extends: BoxComponent,
};
</script>

<template>
  <iframe
    v-if="fileUrl"
    id="file-wrapper-viewer"
    :src="fileUrl"
    @load="onBindFileContextMenu"
  />
</template>